import { render, staticRenderFns } from "./practiceDaily.vue?vue&type=template&id=9f4fe0de&scoped=true"
import script from "./practiceDaily.vue?vue&type=script&lang=js"
export * from "./practiceDaily.vue?vue&type=script&lang=js"
import style0 from "./practiceDaily.vue?vue&type=style&index=0&id=9f4fe0de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4fe0de",
  null
  
)

export default component.exports